import {
  EditButton,
  EmailField,
  ListButton,
  Show,
  SimpleShowLayout,
  TextField,
  TopToolbar,
} from "react-admin";

const ShowActions = () => (
  <TopToolbar sx={{ justifyContent: "space-between" }}>
    <ListButton />
    <EditButton />
  </TopToolbar>
);

export const UserShow = () => (
  <Show actions={<ShowActions />}>
    <SimpleShowLayout>
      <TextField source="username" emptyText="-" />
      <EmailField source="email" emptyText="-" />
    </SimpleShowLayout>
  </Show>
);
